import MediaPage from "./MediaPage";

export default MediaPage;
